module.exports = __webpack_public_path__ + "img/person4.96f7cfc6.svg";